import { call, put, race, take } from 'redux-saga/effects';

import { receiveAPIResponse } from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import {
  PULL_REQUESTED_PDF,
  STOP_PULLING_REQUESTED_PDF,
} from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';
import { stopPullingPdf } from './actions';

export const delay = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export function* repeatedActionSaga(action: ViewAction) {
  let getPDFsList = true;
  while (getPDFsList) {
    yield delay(3500);

    const urlObjId = action.subAction.params.url_format._id_;
    let url = getActionAPISource(action.subAction.dataKey);
    url = url.replace(new RegExp('_id_', 'g'), urlObjId);

    const response = yield call(apiCallAsync, url, {}, 'get');
    if (response.status >= 200 && response.status < 300) {
      if (
        response.data.report.is_generated ||
        response.data.report.is_failed_to_generate
      ) {
        getPDFsList = false;

        yield put(
          receiveAPIResponse(
            action.subAction.dataKey,
            response.data,
            action.subAction.params,
          ),
        );
      }
    } else {
      getPDFsList = false;
      console.warn(`API call GET PDF Reports list failed.`);
    }
  }
  yield put(stopPullingPdf());
}

export function* watchRepeatedActionSaga() {
  let pendingAction: ViewAction | null = null;
  while (true) {
    const action = pendingAction
      ? pendingAction
      : yield take(PULL_REQUESTED_PDF);
    pendingAction = null;

    const { newAction } = yield race({
      success: call(repeatedActionSaga, action),
      stop: take(STOP_PULLING_REQUESTED_PDF),
      newAction: take(PULL_REQUESTED_PDF),
    });

    if (typeof newAction !== 'undefined') {
      pendingAction = newAction;
    }
  }
}
